<!-- app页面——企业回收站 -->
<template>
  <div class="epRecycleH5">
    <van-nav-bar title="回收站" left-arrow @click-left="toBack" />
    <div class="content">
      <!-- 文档列表 -->
      <van-pull-refresh class="folderList" v-model="refreshing" @refresh="onRefresh" v-loading="loading">
        <div class="folderItem" v-for="item in epRecycleList" :key="item.folderId">
          <oneFileFolder :key="item.folderId" :item="item" @moreOpen="moreOpen(item)"></oneFileFolder>
        </div>
        <div class="empty" v-if="!epRecycleList.length">暂无数据</div>
      </van-pull-refresh>
    </div>
    <!-- 更多弹框 -->
    <epRecycleMore ref="epRecycleMore" @toRefresh="toRefresh" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import docService from "@/CommonDP/service/doc-service";
import oneFileFolder from "../../components/oneFileFolder.vue";
import epRecycleMore from "./epRecycleMore.vue";

export default {
  components: { oneFileFolder, epRecycleMore },
  data() {
    return {
      epRecycleList: [], // 企业回收站列表
      refreshing: false,
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getEpRecycleList();
  },
  methods: {
    // 返回上一页
    toBack() {
      this.$router.go(-1);
    },

    // 获得企业回收站列表
    async getEpRecycleList() {
      this.loading = true;
      try {
        let enterpriseId = this.enterpriseId;
        const res = await docService.queryenterpriseRecycle(enterpriseId);
        this.epRecycleList = res.data || [];
      } finally {
        this.loading = false;
      }
    },
    // 刷新列表
    toRefresh() {
      this.getEpRecycleList();
    },
    // 下拉刷新
    async onRefresh() {
      try {
        await this.getEpRecycleList();
      } finally {
        this.refreshing = false;
      }
    },

    // 点击... 打开更多
    moreOpen(item) {
      if (item.isFolder == 1) this.$refs.epRecycleMore.setFolderPrivi(item);
      else this.$refs.epRecycleMore.setFilePrivi(item);
    }
  }
};
</script>

<style lang="scss" scoped>
.epRecycleH5 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f6fa;

  .content {
    width: 100%;
    height: calc(100% - 56px);
    margin-top: 10px;
  }
}

.folderList {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .empty {
    width: 100%;
    height: calc(100% - 66px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--info-color)9;
    font-size: 16px;
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
